import React from "react";

export default function CircularTimer({ value, max }) {
  // value: remaining seconds; max: total seconds
  const radius = 22;
  const circumference = 2 * Math.PI * radius;
  const progress = (value / max) * circumference;

  return (
    <svg width="56" height="56" className="block">
      <circle
        cx="28"
        cy="28"
        r={radius}
        stroke="#e5e7eb"
        strokeWidth="6"
        fill="none"
      />
      <circle
        cx="28"
        cy="28"
        r={radius}
        stroke="#2563eb"
        strokeWidth="6"
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={circumference - progress}
        strokeLinecap="round"
        style={{ transition: "stroke-dashoffset 1s linear" }}
      />
      <text
        x="50%"
        y="53%"
        textAnchor="middle"
        fill="#111827"
        fontSize="18"
        fontWeight="bold"
        dy=".3em"
      >
        {value}
      </text>
    </svg>
  );
}
